const SEED_ALPHABET = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
const SEED_LENGTH = 8;

type RandomBytes = Uint8Array<ArrayBuffer>;
type FillRandomBytes = (bytes: RandomBytes) => void;

function fillWithBrowserCrypto(bytes: RandomBytes): void {
  globalThis.crypto.getRandomValues(bytes);
}

/** Creates a readable UI seed without changing the deterministic engine contract. */
export function generateExpeditionSeed(
  fillRandomBytes: FillRandomBytes = fillWithBrowserCrypto,
): string {
  const bytes = new Uint8Array(new ArrayBuffer(SEED_LENGTH));
  fillRandomBytes(bytes);
  const suffix = Array.from(
    bytes,
    (value) => SEED_ALPHABET[value & 31]!,
  ).join('');
  return `BELLROSE-${suffix}`;
}
